const storage = {
    not_configured: '未配置存儲提供程序。',
    missing_parameter: '存儲提供程序缺少參數 {{parameter}}。',
    upload_error: '無法將文件上載到存儲提供程序。',
};
export default storage;
